/**
 * パスワード表示切替ボタン
 * ログイン・新規登録のパスワード入力欄右端に配置し、入力中の文字を表示・非表示に切り替える共通ボタンです
 */

import React from 'react';
import { Pressable, Text } from './WebPrimitives';

/** パスワード表示切替ボタンのプロパティ */
type PasswordVisibilityToggleButtonProps = {
  /** 現在パスワードを表示しているか */
  isVisible: boolean;
  /** 表示・非表示を切り替えるコールバック */
  onToggle: () => void;
  /** テスト識別子 */
  testID?: string;
};

/**
 * パスワード表示切替ボタン
 * @param {PasswordVisibilityToggleButtonProps} props - プロパティ
 * @returns {React.JSX.Element} パスワード表示切替ボタン
 */
const PasswordVisibilityToggleButton = ({
  isVisible,
  onToggle,
  testID,
}: PasswordVisibilityToggleButtonProps): React.JSX.Element => {
  return (
    <Pressable
      // aria-pressed相当として現在の表示状態を公開する
      aria-pressed={isVisible}
      accessibilityLabel={isVisible ? 'パスワードを隠す' : 'パスワードを表示'}
      accessibilityRole="button"
      className="h-11 min-h-[44px] w-11 min-w-[44px] shrink-0 items-center justify-center border-2 border-app-border bg-[#FFFDF0]"
      onPress={onToggle}
      testID={testID}
    >
      <Text
        accessible={false}
        className="text-[10px] font-bold text-app-text-secondary"
      >
        {isVisible ? '隠す' : '表示'}
      </Text>
    </Pressable>
  );
};

export default PasswordVisibilityToggleButton;
